import { useRef, useState } from 'react';
import { RECORD_QUESTIONS } from '../../data/define';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

function RecordingQuestionCarousel({
  intelligenceId = undefined,
}: {
  intelligenceId?: string | number;
}) {
  const swiperRef = useRef(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const targetIntelligence = RECORD_QUESTIONS.find((item) => item.id === Number(intelligenceId));

  if (!targetIntelligence) return null;

  return (
    <div className="w-full overflow-hidden mx-[20px]">
      <div className="w-full flex items-center justify-between mb-[10px]">
        <div
          className="text-[14px] py-1 px-3 text-[#5EBEBB] rounded-[25px] border border-[#5EBEBB] bg-[#fff] font-[700]"
          style={{ boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)' }}
        >
          Q. {targetIntelligence?.label}
        </div>
        <div
          className="flex items-center justify-between text-[14px] py-1 px-3 text-[#363636] rounded-[25px] bg-[#fff] font-[700] w-[46px]"
          style={{ boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)' }}
        >
          <span>{currentSlideIndex + 1}</span>
          <span>/</span>
          <span>{targetIntelligence?.text?.length || 0}</span>
        </div>
      </div>
      <div
        className="w-full h-full flex justify-center items-center overflow-x-auto bg-[#fff] rounded-xl py-[10px] px-[5px]"
        style={{ boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)' }}
      >
        <Swiper
          ref={swiperRef}
          className="mySwiper h-full flex items-center justify-center"
          style={
            {
              ['--swiper-navigation-color' as any]: '#C6C6C6',
              ['--swiper-navigation-size' as any]: '15px',
            } as React.CSSProperties
          }
          modules={[Navigation]}
          navigation={true}
          spaceBetween={0}
          slidesPerView="auto"
          loop={true}
          centeredSlides={true}
          onSlideChange={(swiper) => {
            setCurrentSlideIndex(swiper.realIndex);
          }}
        >
          {targetIntelligence?.text?.map((text, index) => {
            return (
              <SwiperSlide
                key={`${text}-${String(index)}`}
                style={{
                  height: '100%',
                  minHeight: '100px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                className="w-full h-full text-[20px] text-[#1C1C1C] font-[700]"
              >
                {text?.split('\n')?.map((line, lineIndex) => (
                  <div
                    key={`${text}-${String(index)}-${String(lineIndex)}`}
                    className="w-full text-center"
                  >
                    {line}
                  </div>
                ))}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}

export default RecordingQuestionCarousel;
